export const USERS_COLLECTION = "users";
export const PROJECTS_COLLECTION = "projects";
export const ORGANISATIONS_COLLECTION = "organisations";
export const RELATIONS_COLLECTION = "relations";

export const BOOKINGS_COLLECTION = "bookings";
